import RedesignDescriptor from 'src/components/elements/orderAhead/descriptor/orderAhead-components-redesign-descriptor';
import ConnectPaydescriptor from 'src/components/elements/orderAhead/descriptor/orderAhead-components-connectpay-descriptor';
import CKdescriptor from 'src/components/elements/orderAhead/descriptor/orderAhead-components-companykitchen-descriptor';
import Refivedescriptor from 'src/components/elements/orderAhead/descriptor/orderAhead-components-refive-descriptor';
import Aramarkdescriptor from 'src/components/elements/orderAhead/descriptor/orderAhead-components-aramark-descriptor';
import Settings from 'src/Settings';
import {StyleProp, TextStyle, ViewStyle} from 'react-native';
import type {TimeSlotType} from 'src/types/Menu';
import {BuildTypeEnum} from 'src/constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: Aramarkdescriptor,
  [BuildTypeEnum.canteen]: ConnectPaydescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CKdescriptor,
  [BuildTypeEnum.refive]: Refivedescriptor,
};

export interface CustomTilesButtonStylesDescriptor {
  tileContainer: StyleProp<ViewStyle>;
  text: StyleProp<TextStyle>;
  selectedText: StyleProp<TextStyle>;
  selectedView: StyleProp<ViewStyle>;
}
export interface PickupLocationListStylesDescriptor {
  cell: StyleProp<ViewStyle>;
  cellSelected: StyleProp<ViewStyle>;
  label: StyleProp<TextStyle>;
  selectedLabel: StyleProp<TextStyle>;
}
export interface ProductModifierStylesDescriptor {
  customizationDivider?: StyleProp<ViewStyle>;
  productModifierContainer?: StyleProp<ViewStyle>;
  radioButtonWrapper?: StyleProp<ViewStyle>;
  checkboxRow?: StyleProp<ViewStyle>;
  checkboxNameContainer?: StyleProp<ViewStyle>;
  checkboxPriceContainer?: StyleProp<ViewStyle>;
  checkboxCalorieContainer?: StyleProp<ViewStyle>;
  requiredViewStyles?: StyleProp<ViewStyle>;
  checkBoxWrapper?: StyleProp<ViewStyle>;
  options?: StyleProp<ViewStyle>;
  titleRow?: StyleProp<ViewStyle>;
  titleText?: StyleProp<TextStyle>;
  requiredText?: StyleProp<TextStyle>;
  totalCaloriesLabel?: StyleProp<TextStyle>;
  sectionCalStyles?: StyleProp<TextStyle>;
  optionText?: StyleProp<TextStyle>;
  checkBoxText?: StyleProp<TextStyle>;
  helperText?: StyleProp<TextStyle>;
  freeTextContainer?: StyleProp<ViewStyle>;
  freeTextContent?: StyleProp<ViewStyle>;
}
export interface ProductModifierRadioButton {
  label?: string;
  price?: string;
  value?: string;
  calories?: number;
}

export interface RecentOrdersButtonStylesDescriptor {
  marginStyle?: StyleProp<ViewStyle>;
  textUnderline?: StyleProp<ViewStyle>;
  recentOrderText?: StyleProp<TextStyle>;
}

export type CheckoutBarProps = {
  numItems: number;
  onPress: () => void;
  displayLocation: string;
  pickupTime?: TimeSlotType;
  label?: string;
  totalAmount?: string;
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
